import React, { useRef, useState } from 'react';

import { useEventing } from 'commons/eventing';
import { AskAIButton } from 'craft/components/SelectedToolbar/AskAI/components/AskAIButton';
import { AskAICallout } from 'craft/components/SelectedToolbar/AskAI/components/AskAICallout';

interface RenderProps {
  toggleOpen: VoidFunction;
}

export const AskAI = ({ children }: { children: (attr: RenderProps) => React.ReactNode }) => {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { track } = useEventing();

  const toggleOpen = () => {
    if (!isOpen) {
      track('editor.firstMate.modifyText.opened');
    }

    setIsOpen(!isOpen);
  };

  const childrenEl = children({
    toggleOpen,
  });

  return (
    <>
      <AskAIButton isOpen={isOpen} toggleOpen={toggleOpen} ref={triggerRef} />

      <AskAICallout
        isOpen={isOpen}
        referenceElement={triggerRef.current}
        onClose={() => setIsOpen(false)}
      >
        {childrenEl}
      </AskAICallout>
    </>
  );
};
